import React, { Component } from "react";
import PropTypes from "prop-types";

import Form from "./Form";
import { connect } from "react-redux";
import { checkEmployeeExists } from "../../actions/employeeActions";
import Grid from "@material-ui/core/Grid";
import { TextField } from "@material-ui/core";

class CheckEmployeeExistsForm extends Component {
  state = {
    email: "",
  };

  checkUserExists = (e) => {
    e.preventDefault();

    this.props.checkEmployeeExists(this.state).then((response) => {
      this.props.onSuccess({
        ...response,
        email: this.state.email,
      });
    });
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    return (
      <Form
        onSubmit={this.checkUserExists}
        submitText="Check"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <TextField
              id="email"
              name="email"
              label="Email *"
              value={this.state.email}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

CheckEmployeeExistsForm.propTypes = {
  checkEmployeeExists: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  exists: state.employee.checkEmployeeExists.exists,
  successMessage: state.employee.checkEmployeeExists.successMessage,
  errorMessage: state.employee.checkEmployeeExists.errorMessage,
  isFetching: state.employee.checkEmployeeExists.isFetching,
});

export default connect(mapStateToProps, { checkEmployeeExists })(
  CheckEmployeeExistsForm,
);



// WEBPACK FOOTER //
// ./src/components/forms/CheckEmployeeExistsForm.js